import React from 'react';
import PropTypes from 'prop-types';

import Download from '@bitcoin-portal/bitcoincom-pkg-components/dist/Download';
import { Apps } from './styled';

const DownloadLinks = ({ center }) => {
  return (
    <Apps center={center}>
      <Download
        link="https://apps.apple.com/us/app/bitcoin-wallet-by-bitcoin-com/id1252903728?ls=1"
        type="ios"
        style={{ zIndex: '99' }}
        className="ga-wallet-cta"
      />
      <Download
        link="https://play.google.com/store/apps/details?id=com.bitcoin.mwallet"
        type="google"
        style={{ zIndex: '99' }}
        className="ga-wallet-cta"
      />
    </Apps>
  );
};

DownloadLinks.propTypes = {
  center: PropTypes.bool,
};

DownloadLinks.defaultProps = {
  center: false,
};

export default DownloadLinks;
